import ApiCalls from "../../config/apiCalls";
import Headers from "../../config/paymentConfig/headers";
import {
  PAYMENT_ACTION,
  PAYMENT_METHOD,
  wallet,
} from "../../helpers/paymentHelpers/paymentConstants";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import get from "lodash/get";
import Utility from "../../helpers/utility";
import { EXCLUDE_TIP_PAYMENT_MODES } from "../../helpers/paymentConstants";
import {
  keyMapsAction,
  keyMapsMutation,
} from "../../helpers/paymentHelpers/storeKeys";

export default {
  namespaced: true,
  state: {
    lastSuccessfullPayment: {},
  },
  getters: {
    getShowThankYouModal(state) {
      return state.showThankYou;
    },
  },
  mutations: {
    updateLastSuccessfullPaymentData(state, payload) {
      state.lastSuccessfullPayment = payload;
    },
    setPaymentMode(state, payload) {
      if (!payload) {
        return {
          ...state,
          paymentMode: {},
        };
      }
      // TODO: Check why is this here
      // if (action.query.pType === null) {
      //   return state;
      // }
      localStorage.paymentMode = JSON.stringify(payload.pType);
      return {
        ...state,
        paymentMode: {
          ...state.paymentMode,
          paymentType: payload.pType,
          [payload.pType.name]: payload.response,
        },
      };
    },
  },
  actions: {
    getLastSuccessFullPaymentApi({ commit, dispatch }, payload) {
      ApiCalls.LAST_SUCCESSFULL_PAYMENT_API({
        headers: { ...Headers() },
        payload: payload,
      })
        .then(function (response) {
          if (
            response?.data?.paymentOption &&
            !response.data.isPaymentOptionBlocked &&
            get(response.data, "paymentOption.paymentId", "") !==
              PAYMENT_METHOD.AMAZON_WALLET
          ) {
            const {
              paymentOption: {
                paymentId = "",
                label = "",
                status = "",
                paymentMode = "",
                img_url = "",
                providers = [],
              } = {},
              lastUsedCard = {},
              paymentUrl = "",
            } = response.data;

            // ve5 API for last successful transaction has different DTO that contains providers and ve2 does not contain providers
            let paymentModeObject = providers.length
              ? Utility.convertProviderOptionToPaymentOption(providers[0])
              : {
                  name: paymentId,
                  index: 0,
                  label,
                  paymentId,
                  status,
                  paymentMode,
                  paymentUrl,
                  img_url,
                };
            const storedPaymentMode = Utility.tryJsonParse(
              localStorage.paymentMode
            );

            if (
              (paymentModeObject?.paymentId == "CC" ||
                paymentModeObject?.paymentId == "DC" ||
                paymentModeObject?.paymentMode == "CARD") &&
              (lastUsedCard?.cardId || lastUsedCard?.id)
            ) {
              paymentModeObject = Object.assign(
                {},
                paymentModeObject,
                lastUsedCard
              );
              commit(
                keyMapsMutation.UPDATE_SELECTED_BANK_CVV_DATA,
                { ...lastUsedCard } || {},
                { root: true }
              );
            }

            if (!get(storedPaymentMode, "paymentId", "")) {
              commit("setPaymentMode", {
                pType: paymentModeObject,
              });
              dispatch(
                keyMapsAction.SET_PAYMENT_MODE_ACTION,
                paymentModeObject,
                { root: true }
              );
            }
            // EventTracker(GTMEvents.paymentOptionOnCart.type, {
            //   ...GTMEvents.paymentOptionOnCart.payload,
            //   eventAction: 'Last Successful Payment',
            //   eventLabel: get(response, 'paymentOption.paymentId', '')
            // });
            if (paymentModeObject?.paymentId) {
              localStorage.isPaymentModeAvailable = true;
            }
            commit("updateLastSuccessfullPaymentData", response.data);
            if (
              EXCLUDE_TIP_PAYMENT_MODES.includes(
                get(response.data, "paymentOption.paymentId", "")
              )
            ) {
              //   const cartItems = get(state, 'menu.cartItems', []);
              //   const tip = { tipRemoved: true, tipAmount: 0 };
              //   const optedOptionalCharges = [
              //     {
              //       chargeTypeCode: 'K',
              //       selected: false
              //     }
              //   ];
              //   const currentStack: {
              //     data: {
              //       items: cartItems,
              //       tip,
              //       optedOptionalCharges
              //     }
              //   };
              //   if (cartItems.length) {
              //     yield put(putCart(currentStack, true));
              //   }
            }
          } else {
            // yield put(setPaymentType());
            // const userInfo = getStorageValue(localStorage.USER_INFO);
            // EventTracker(GTMEvents.paymentOptionOnCart.type, {
            //   ...GTMEvents.paymentOptionOnCart.payload,
            //   eventAction: "Last Successful payment not shown",
            //   eventLabel: get(userInfo, "headers.isLoggedIn", "")
            //     ? "Logged in New User"
            //     : "Anonymous User",
            // });
            commit("updateLastSuccessfullPaymentData", {});
            localStorage.isPaymentModeAvailable = "";
            // setStorageValue('paymentMode', '');
            localStorage.isWalletSelected = "";
            localStorage.totalWalletBalance = "";
          }
          if (response?.data?.paymentUrl) {
            localStorage.paymentUrl = response.data.paymentUrl;
          }
        })
        .catch(function (error) {
          console.log(error);
          commit("updateLastSuccessfullPaymentData", {});
        });
    },
  },
};
